var globalFunctions = {
    checkVisible ( isAdminItem ) {
        return isAdminItem ? parseInt(  window.localStorage.getItem('role_id') ) < 3 : true;
    }
}
export default globalFunctions